export default "__VITE_ASSET__086f12d0__"